const config = require('../config');
const apiConfig = require('../api-config');
const apiFactory = require('../resources/push-notification/api-factory');
const serviceFactory = require('../resources/push-notification/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/pushnotification/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match((
      `${p}pushnotification.pushRegistration[{keys:inputs}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.pushRegistration(req.params.inputs, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

    .match((
      `${p}pushnotification.getFCMSenderId`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getFCMSenderId(req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))
}

module.exports = addRoutes;
